var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 75,
    viewBox: "0 0 60 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1876_5747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5182 74.6001C59.3576 74.7685 59.0437 74.8877 58.8247 75L1.03662 74.9369C0.313907 74.6632 0.0219005 73.9195 0 73.2039L0.109502 1.17867C0.321207 0.449018 0.90522 0 1.72284 0L41.0415 0.140318C47.4437 5.69691 53.3642 11.892 59.5766 17.6941L59.9927 19.0552V73.2039C59.9927 73.6389 59.8102 74.2844 59.5109 74.6001H59.5182ZM39.0485 2.94668H3.05877V72.1235H56.9339V20.3391H40.567C40.1436 20.3391 39.0412 19.7147 39.0412 19.2657V2.94668H39.0485ZM54.7001 17.4065L41.8956 5.09355V17.1118L42.2022 17.4065H54.7074H54.7001Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6141 38.1167C41.0672 39.0849 44.469 43.3015 44.9216 47.6163C45.3742 51.931 43.9288 54.548 39.3516 54.9198C34.4167 55.3127 25.8025 55.2846 20.8457 54.9338C10.2897 54.1761 15.6261 39.1831 23.3935 38.1167C23.0504 37.2818 22.2327 36.7837 21.6852 35.9558C18.3053 30.8763 21.2618 23.5938 27.3064 22.0433C36.4461 19.7 43.3302 29.4942 37.7164 36.7346C37.512 37.0012 36.3877 37.8782 36.6141 38.1167ZM36.7236 31.0517C36.7236 27.4876 33.7159 24.5901 30.0001 24.5901C26.2843 24.5901 23.2767 27.4806 23.2767 31.0517C23.2767 34.6228 26.2843 37.5134 30.0001 37.5134C33.7159 37.5134 36.7236 34.6228 36.7236 31.0517ZM25.3791 40.5162C20.6194 41.1336 17.6701 45.5045 18.1009 49.9525C18.2323 51.3206 19.0645 51.8819 20.4442 52.0012C26.5033 52.5484 33.4239 51.5732 39.5706 52.0012C40.7386 52.0082 41.768 51.2715 41.9067 50.142C42.3812 46.3113 40.3079 42.4385 36.5191 41.0494C34.3291 40.2496 27.8101 40.2004 25.3864 40.5162H25.3791Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3195 61.0383C27.502 60.8208 28.0568 60.6173 28.3707 60.5822C33.8823 59.9227 40.8102 61.0944 46.4751 60.5822C48.5191 60.7717 48.4534 63.2974 46.4751 63.5219C40.8321 63.0448 34.0867 64.1393 28.5751 63.5219C27.356 63.3816 26.4727 62.0415 27.3195 61.0312V61.0383Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1672 14.5163L25.7162 14.4883C27.5704 14.7689 27.3003 17.1543 25.7162 17.3929H13.3424C11.7218 17.007 11.4955 15.0496 13.1672 14.5163Z",
    fill: "#1D00C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1689 60.6306C16.0524 60.8551 19.8996 60.1816 22.6664 60.6026C24.4403 60.8692 24.433 63.2476 22.6664 63.5142C21.2137 63.7317 14.7822 63.7317 13.3368 63.5142C11.7381 63.2686 11.5044 61.0726 13.1616 60.6377L13.1689 60.6306Z",
    fill: "#1D00C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1876_5747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersIcon);
export default __webpack_public_path__ + "static/media/CareersIcon.7a71e3f8c0f1380d812e085f3a19fdf2.svg";
export { ForwardRef as ReactComponent };